import { useLocalStorage } from 'platform-components/src/utils/hooks/useLocalStorage';
import { useCallback } from 'react';

import { QuizDraft } from './typings';
import { getEmptyQuizTemplate } from './utils';

export const useQuizDraftInLocalStorage = () => {
    const { get: getFromLocalStorage, remove: removeFromLocalStorage, set: setInLocalStorage } = useLocalStorage();

    const saveQuizDraftInLocalStorage = useCallback(
        (quizDraft: QuizDraft) => {
            const quizDraftToSave = JSON.stringify(quizDraft);
            setInLocalStorage('quizDrafts', { new: quizDraftToSave });
        },
        [setInLocalStorage]
    );

    const deleteQuizDraftFromLocalStorage = useCallback(() => {
        removeFromLocalStorage('quizDrafts');
    }, [removeFromLocalStorage]);

    const getQuizDraftFromLocalStorage = useCallback(() => {
        const quizDraftsFromLocalStorage = getFromLocalStorage('quizDrafts');
        try {
            return JSON.parse(quizDraftsFromLocalStorage.new);
        } catch {
            return getEmptyQuizTemplate();
        }
    }, [getFromLocalStorage]);

    return { saveQuizDraftInLocalStorage, deleteQuizDraftFromLocalStorage, getQuizDraftFromLocalStorage };
};
